'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectives = require('../actions/objectives');

var defaultState = [];

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    switch (action.type) {
        case _objectives.actionTypes.FETCH_OBJECTIVES_SUCCEEDED:
            return action.objectives;
        default:
            return state;
    }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvcmVkdWNlcnMvb2JqZWN0aXZlcy5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0U3RhdGUiLCJzdGF0ZSIsImFjdGlvbiIsInR5cGUiLCJhY3Rpb25UeXBlcyIsIkZFVENIX09CSkVDVElWRVNfU1VDQ0VFREVEIiwib2JqZWN0aXZlcyJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7O0FBRUEsSUFBTUEsZUFBZSxFQUFyQjs7a0JBRWUsWUFBa0M7QUFBQSxRQUFqQ0MsS0FBaUMsdUVBQXpCRCxZQUF5QjtBQUFBLFFBQVhFLE1BQVc7O0FBQzdDLFlBQVFBLE9BQU9DLElBQWY7QUFDSSxhQUFLQyx3QkFBWUMsMEJBQWpCO0FBQ0ksbUJBQU9ILE9BQU9JLFVBQWQ7QUFDSjtBQUNJLG1CQUFPTCxLQUFQO0FBSlI7QUFNSCxDIiwiZmlsZSI6Im9iamVjdGl2ZXMuanMiLCJzb3VyY2VSb290IjoiL3NyYyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGFjdGlvblR5cGVzIH0gZnJvbSAnLi4vYWN0aW9ucy9vYmplY3RpdmVzJztcblxuY29uc3QgZGVmYXVsdFN0YXRlID0gW107XG5cbmV4cG9ydCBkZWZhdWx0IChzdGF0ZSA9IGRlZmF1bHRTdGF0ZSwgYWN0aW9uKSA9PiB7XG4gICAgc3dpdGNoIChhY3Rpb24udHlwZSkge1xuICAgICAgICBjYXNlIGFjdGlvblR5cGVzLkZFVENIX09CSkVDVElWRVNfU1VDQ0VFREVEOlxuICAgICAgICAgICAgcmV0dXJuIGFjdGlvbi5vYmplY3RpdmVzO1xuICAgICAgICBkZWZhdWx0OlxuICAgICAgICAgICAgcmV0dXJuIHN0YXRlO1xuICAgIH1cbn07Il19


//////////////////
// WEBPACK FOOTER
// ./src/client/reducers/objectives.js
// module id = 2256
// module chunks = 0